import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { Collapse } from '@mui/material';
import { Grow } from '@mui/material';
import { Zoom } from '@mui/material';

import SignIn from './SignIn';
// import ForgotPattern from './ForgotPattern';
import GridButtons from './GridButtons';
// import PassCode from './PassCode';
// import GridSlider from './GridSlider';

// import '../../css/flip.css';
import '../../css/jb-styles.css';

// import pointMe from '../../images/circle2.svg';
// import EmergencyIcon from '@mui/icons-material/Emergency';

import {
  gridArray,
  incrementGridArray,
  decrementGridArray,
  rightSwipeIncrement,
  leftSwipeIncrement,
  clickCount,
  undoCount,
} from '../../../redux/challengeSlice';

// import {
//   registeredPattern,
// } from '../../../redux/pattern';

import { useSwipeable } from 'react-swipeable';

export default function Grid() {
  // const theme = useTheme();

  const [flip, setFlip] = useState(false);
  const [clicked, setClicked] = useState(0);
  const [displayMessage, setDisplayMessage] = useState(null);

  const gridArrayState = useSelector((state) => state.challenge.gridArray);
  const incrementGridArrayState = useSelector((state) => state.challenge.incrementGridArray);
  const decrementGridArrayState = useSelector((state) => state.challenge.decrementGridArray);
  const registeredPatternState = useSelector((state) => state.challenge.registeredPattern);
  const selectedCellState = useSelector((state) => state.challenge.selectedCell);
  const codeArrayState = useSelector((state) => state.challenge.codeArray);
  const signinResultState = useSelector((state) => state.challenge.signinResult);

  const handlers = useSwipeable({
    onSwipedRight: (eventData) => incrementGridArrayHandler(),
    onSwipedLeft: (eventData) => decrementGridArrayHandler(),
    // onTap: (eventData) => clickHandler(),
    // onSwiping: (eventData) => swipingHandler(),
    swipeDuration: 500,
    preventScrollOnSwipe: true,
    trackMouse: true
  });

  const dispatch = useDispatch();

  useEffect(() => {
    console.log('clicked: ', clicked);
  }, [clicked]);

  useEffect(() => {
    if (incrementGridArrayState.length == 0) {
      // Do nothing
    } else {
      dispatch(gridArray(incrementGridArrayState));
      dispatch(rightSwipeIncrement());
    }
  }, [incrementGridArrayState]);

  useEffect(() => {
    if (decrementGridArrayState.length == 0) {
      // Do nothing
    } else {
      dispatch(gridArray(decrementGridArrayState));
      dispatch(leftSwipeIncrement());
    }
  }, [decrementGridArrayState]);

  const incrementGridArrayHandler = () => {
    setFlip(!flip);
    dispatch(decrementGridArray());
  };

  const decrementGridArrayHandler = () => {
    setFlip(!flip);
    dispatch(incrementGridArray());
  };

  const createCellClassName = (rowIndex, columnIndex) => {
    let cellClassName = '';

    switch (rowIndex) {
      case 0:
      case 5:
        switch (columnIndex) {
          case 0:
          case 5:
            cellClassName = 'jb-border-200';
            break;
          default:
            cellClassName = 'jb-border-200';
        }
        break;
      case 1:
      case 4:
        switch (columnIndex) {
          case 0:
          case 5:
            cellClassName = 'jb-border-200';
            break;
          case 1:
          case 4:
          case 2:
          case 3:
            cellClassName = 'jb-border-400';
            break;
          default:
            cellClassName = 'jb-border-200';
        }
        break;
      case 2:
      case 3:
        switch (columnIndex) {
          case 0:
          case 5:
            cellClassName = 'jb-border-200';
            break;
          case 1:
          case 4:
            cellClassName = 'jb-border-400';
            break;
          case 2:
          case 3:
            cellClassName = 'jb-border-300';
            break;
          default:
            cellClassName = 'jb-border-200';
        }
        break;
      default:
        cellClassName = 'jb-border-200';
    }

    return cellClassName;
  }

  const clickHandler = () => {

    if (registeredPatternState.length == 0) {
      alert('Please set pattern first');
      return;
    }

    dispatch(clickCount());
    setClicked(clicked + 1);
  };

  const result = () => {
    if (signinResultState == true) {
      setDisplayMessage(true);
    } else {
      setDisplayMessage(false);
    }
  };

  const undo = () => {
    dispatch(undoCount());
    setClicked(clicked - 1);
  };

  return (

    <React.Fragment>

      <Box
        sx={{
          borderBottom: '2px solid #3B4E68',
          paddingTop: '10px',
          paddingBottom: '10px',
        }}
      >
        <Typography
          variant='body1'
          sx={{
            fontSize: '0.8em',
            color: '#3B4E68',
          }}
        >
          Swipe to align selector with your pattern
        </Typography>
      </Box>

      <Box
        id='vauth-swipe-grid-container'
        sx={{
          padding: '20px',
          paddingBottom: 0,
          // paddingBottom: '20px',
          width: '100%',
          alignSelf: 'center',
          // cursor: `url('/sites/default/files/media/image/circle2.svg'), auto`,
          // cursor: `url('/client/images/circle2.svg'), auto`,
          userSelect: 'none',
          cursor: 'pointer',
          // cursor: { pointMe }
        }}
        {...handlers}
      >

        {gridArrayState.map((row, rowIndex) => (
          <Box
            key={`grid-row${rowIndex}`}
            id={`grid-row${rowIndex}`}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '5px',
            }}>
            {row.map((cell, columnIndex) => (
              // <Collapse
              //   in={flip}
              //   orientation='horizontal'
              //   timout={5000}
              //   easing={'ease-in-out'}
              //   key={`grid-column${columnIndex}`}
              // >
              // <Zoom
              //   in={true}
              //   timeout={750}
              //   // easing={'ease-in-out'}
              //   key={`grid-column${columnIndex}-${new Date().getMilliseconds()}`}
              // >
              <Box
                key={`grid-column${columnIndex}`}
                className={`card jb-cell ${flip ? 'flip' : ''} ${createCellClassName(rowIndex, columnIndex)}`}
                sx={{
                  padding: '10px',
                  width: '15%',
                  aspectRatio: '1 / 1',
                  // color: 'aliceblue',
                  color: '#3B4E68',
                  // borderStyle: 'outset',
                  // backgroundColor: '#abd8ee',
                }}
              >

                <div className={flip ? `back` : ``}>


                  {cell}

                </div>

              </Box>

              // </Zoom>
            ))}
          </Box>
        ))
        }


        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingTop: '10px',
            paddingLeft: '20px',
            paddingRight: '20px',
            height: '40px',
          }}
        >
          {/* {signinResultState == null ? */}
          {displayMessage == null ?
            <React.Fragment>
              <Box
                sx={{
                  width: '10%',
                }}
              >
                {clicked > 0 ? '*' : null}
              </Box>

              <Box
                sx={{
                  width: '10%',
                }}
              >
                {clicked > 1 ? '*' : null}
              </Box>

              <Box
                sx={{
                  width: '10%',
                }}
              >
                {clicked > 2 ? '*' : null}
              </Box>

              <Box
                sx={{
                  width: '10%',
                }}
              >
                {clicked > 3 ? '*' : null}
              </Box>

              <Box
                sx={{
                  width: '10%',
                }}
              >
                {clicked > 4 ? '*' : null}
              </Box>

              <Box
                sx={{
                  width: '10%',
                }}
              >
                {clicked > 5 ? '*' : null}
              </Box>
            </React.Fragment>
            // : signinResultState == true
            : displayMessage == true
              ? <Box
                sx={{
                  color: 'green',
                  width: '100%',
                }}
              >
                Login successful
              </Box>
              :
              <Box
                sx={{
                  color: 'red',
                  width: '100%',
                }}
              >
                Login failed
              </Box>
          }

        </Box>

      </Box >

      {/* <PassCode /> */}
      {/* <GridSlider /> */}
      {/* <Enter onTap={clickHandler} /> */}
      <GridButtons onTap={clickHandler} undo={undo} />
      {/* <ForgotPattern /> */}
      <SignIn clicked={clicked} handler={result} />

    </React.Fragment>

  )
}
